module.exports = __webpack_public_path__ + "img/abcs-select-en-a.214905b4.png";